import axios, { InternalAxiosRequestConfig, AxiosHeaders } from "axios";

const api = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL,
    headers: {
        "Content-Type": "application/json",
    },
    withCredentials: true
});

const tokenClient = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL,
    withCredentials: true
});

let csrfToken: string | null = null;

// ============== INTERCEPTOR CSRF ==============
api.interceptors.request.use(
    async (config: InternalAxiosRequestConfig) => {
        // Solo agregar token CSRF para requests que modifican datos
        const methodsRequiringCsrf = ['POST', 'PUT', 'DELETE', 'PATCH'];

        if (methodsRequiringCsrf.includes(config.method?.toUpperCase() || '')) {
            if (!csrfToken && config.url !== '/TokenCSRF/GetTokenCSRF') {

                try {
                    const response = await tokenClient.get("/TokenCSRF/GetTokenCSRF");
                    csrfToken = response.data.token;
                } catch (error) {
                }
            }

            if (csrfToken) {
                config.headers = config.headers ?? new AxiosHeaders();
                config.headers.set("X-CSRF-TOKEN", csrfToken);
            }
        }

        return config;
    },
    error => Promise.reject(error)
);

// ============== INTERCEPTOR DE RESPUESTA ==============
// Manejar errores de CSRF
api.interceptors.response.use(
    response => response,
    async error => {
        const originalRequest = error.config;

        // Si el error es 403 y está relacionado con CSRF, intentar renovar el token
        if (error.response?.status === 403 && !originalRequest._retry) {
            const errorData = error.response?.data;

            if (errorData?.code?.includes("CSRF")) {
                originalRequest._retry = true;

                try {
                    const response = await tokenClient.get("/TokenCSRF/GetTokenCSRF");
                    csrfToken = response.data.token;
                    originalRequest.headers["X-CSRF-TOKEN"] = csrfToken;
                    return api.request(originalRequest);
                } catch (retryError) {
                }
            }
        }

        return Promise.reject(error);
    }
);

export default api;